import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Box, Grid, } from '@mui/material';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { CashTxnCRU, NonCashTxnCRU, SecurityDepositConfig, SecurityDepositCRU, SecurityDepositListing, sdObj, cashTxnObj, nonCashTxnObj } from '../components';
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader, STableLoader ,STabsLoader} from '../../../../shared_elements';
import { ShowAttachments, DeletePopUp, ButtonLoader, } from '../../../../shared_elements/components';
import { RoleBaseAccess } from '../../../../hoc';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { getSecurityDepositApi, deleteSecurityDepositApi, getSecurityDepositConfig, deleteTxnApi, getCurrencyApi, getCashTxnApi } from '../apiService';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getStorage } from '../../../../shared_elements/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const SecurityDeposit = () => {
    const dispatch=useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [stabLoader, setStabLoader] = useState(false)
    const [sdcData, setsdcData] = useState({})
    const [currency, setCurrency] = useState([])
    const [cashTxnSorting, setTxnSortingApi] = useState({ list: [], pagination: {}, })
    const [dropDownLoader,setDropDownLoader]=useState(false)
    const [securityDepositInfo, setSecurityDepositInfo] = useState({ list: [], pagination: {}, })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [securityDepositCRU, setSecurityDepositCRU] = useState({ modal: false, data: null, mode: '' })
    const [deleteSecurityDeposit, setDeleteSecurityDeposit] = useState({ modal: false, data: null })
    const [txnCRU, setTxnCRU] = useState({ modal: false, data: null, mode: '', txntype: '' })
    const [deleteTxn, setDeleteTxn] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '', txnType: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null, txnType: '', mode:'' })
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})

    useEffect(() => {
        if (!sdcData?.base_currency && securityDepositInfo?.length) {
            const updatedList = securityDepositInfo.map((item) => ({
                ...item,
                base_amount: null
            }));
            setSecurityDepositInfo((prev) => ({
                ...prev,
                list: updatedList
            }));
        }
        getSecurityDepositList('skeletonLoader');
    }, [sdcData?.base_currency]);

    useEffect(() => {
        const uploadedFileData = getApiResponse("security_deposit" || "security_deposit_transaction", slug);
        getCurrency()
        getSDCList('skeletonLoader')
        getSecurityDepositList('skeletonLoader');
        trackActivity('Page Viewed',{ page_title: 'Security Deposit'})
        setUploadFileProgressData({uploadedFileData});

    }, [])

    const getCurrency = () => {
        setDropDownLoader(true)
        globalGetService(getCurrencyApi())
            .then(response => {
                setDropDownLoader(false)
                if (checkApiStatus(response)) {
                    setCurrency(response?.data?.data || [])
                }
            })
    }
    const getSDCList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setStabLoader(true) : setLoading(true);
        globalGetService(getSecurityDepositConfig(params, query))
            .then(response => {
                if (checkApiStatus(response)) {
                    loaderType === 'skeletonLoader' ? setStabLoader(false) : setLoading(false);
                    setsdcData(response.data.data);
                } else {
                    loaderType === 'skeletonLoader' ? setStabLoader(false) : setLoading(false);
                }
            })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"security_deposit"}))
    }


    const getSecurityDepositList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getSecurityDepositApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setSecurityDepositInfo(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
    }
    const deleteSecurityDepositFn = () => {
        setLoading(true);
        globalDeleteService(deleteSecurityDepositApi(params), { ids: [deleteSecurityDeposit?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Security Deposit`, success_msg: response?.data?.message, item_ids: deleteSecurityDeposit?.data, response: response?.data })
                    setDeleteSecurityDeposit({ modal: false, data: null });
                    getSecurityDepositList('pageloader');
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Security Deposit`, error_msg: response?.data?.message, item_ids: deleteSecurityDeposit?.data, response: response?.data })
                }
            })
    }
    const deleteTxnFn = () => {
        setLoading(true);
        globalDeleteService(deleteTxnApi({ ...params, slug: bulk?.securitySlug }),
            { ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? bulk?.ids.map(item => item?.id) : [deleteTxn?.data?.id] }
        )
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Security Deposit Txn`, success_msg: response?.data?.message, item_ids: deleteTxn?.data || bulk?.ids, response: response?.data })
                    if (sortInfo[deleteTxn?.data?.security_deposit_slug]?.sort) {
                        getTxnListApi(sortInfo[deleteTxn?.data?.security_deposit_slug], deleteTxn?.data?.security_deposit_slug)
                    }
                    setDeleteTxn({ modal: false, data: null });
                    getSecurityDepositList('pageloader');
                    setBulk({ modal: false, ids: [], title: '', type: '', txnType: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Security Deposit Txn`, error_msg: response?.data?.message, item_ids: deleteTxn?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const toggleBulkOps = (flag, type, item, txnType) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [], txnType: txnType, });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id), txnType: txnType })
        }
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (securityDepositCRU?.modal) {
            setSecurityDepositCRU({
                ...securityDepositCRU,
                data: {
                    ...securityDepositCRU.data,
                    attachments: securityDepositCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        if (txnCRU?.modal) {
            setTxnCRU({
                ...txnCRU,
                data: {
                    ...txnCRU.data,
                    attachments: txnCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getSecurityDepositList('pageloader');
    }

    const createSortHandler = (key, securitySlug) => {
        const currentSort = sortInfo[securitySlug] || {};
        let newSort = { sort_by: key };

        if (currentSort.sort_by === key) {
            newSort.sort = currentSort.sort === 'asc' ? 'desc' : 'asc';
        } else {
            newSort.sort = 'asc';
        }
        setSortInfo(prev => ({ ...prev, [securitySlug]: newSort }));
        getTxnListApi({ ...newSort }, securitySlug);
    };

    const getTxnListApi = (query = {}, securitySlug) => {
        setLoading(true);
        globalGetService(getCashTxnApi({ ...params, slug: securitySlug }, query))
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    const { data = [] } = response?.data;
                    setTxnSortingApi(prev => ({
                        ...prev,
                        [securitySlug]: data
                    }));
                }
            })
    }

    const handleExport=()=>{
     seIsExport(true);
     globalGetService(getSecurityDepositApi( params, { export: true})).then((response)=>{
         if (checkApiStatus(response)){
           enqueueSnackbar(
                  response?.data.message,
                  { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                 seIsExport(false);
         }
     })
    }

 const handleUpload = async (slug , modalName, mode) => {
      setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: modalName==="nonTxn" ? "security_deposit_transaction" : "security_deposit",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments,response }) => {
                setUploadFileProgressData({ progressRefs, attachments,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getSecurityDepositList("fetch", { per_page: 20 });
            },
            onError: (err) => {
                enqueueSnackbar(err?.message || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Deposit`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="technical"/>
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Security Deposit" type="technical" />
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 4, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right',minHeight:'35px' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {securityDepositInfo?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['C'] }}>
                                        {/* {sdcData?.base_currency?.id && sdcData?.base_currency?.id ? */}
                                        {sdcData?.contractual_currency?.id ?
                                            <li className='lease-mobile-button'>
                                                <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setSecurityDepositCRU({ modal: true, data: sdObj, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Security Deposit</Button>
                                            </li> : null}
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div className='lease-detail-table security-deposit-container' square>
                        {stabLoader ?  <STabsLoader count={7} /> : (<>
                            <SecurityDepositConfig
                                sdcData={sdcData ? sdcData : sdcData }
                                dropDownLoader={dropDownLoader}
                                getResponseBack={() => getSDCList('pageloader')}
                                currencyData={currency}
                                securityDepositInfo={securityDepositInfo?.length > 0}
                            />
                            </>)}
                            {skeletonLoader ? <STableLoader count={4} /> : (<> 
                            {securityDepositInfo?.length > 0 ? securityDepositInfo?.map((item, index) => {
                              const uploadedFileData = getApiResponse("security_deposit" || "security_deposit_transaction", item?.slug);
                             return (
                                  <div style={{ marginBottom: "20px" }} >
                                    <SecurityDepositListing
                                        slug={slug?.slug}
                                        setUploadFileStatus={setUploadFileStatus}
                                        uploadedFileData={uploadedFileData }
                                        uploadFileProgressData={uploadFileProgressData}
                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                        sdcData={sdcData}
                                        item={item}
                                        index={index}
                                        sortInfo={sortInfo}
                                        createSortHandler={createSortHandler}
                                        bulk={bulk}
                                        cashTxnSorting={cashTxnSorting}
                                        setBulk={setBulk}
                                        toggleBulkOps={toggleBulkOps}
                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                        onDeleteTxn={(txnData) => {
                                            setBulk({ modal: false, ids: txnData?.id ? [txnData] : [], title: '', type: txnData?.id ? 'single' : '', txnType: item?.security_deposit_type?.value, securitySlug: txnData?.security_deposit_slug || item?.slug,
                                            });
                                            setDeleteTxn({ modal: true, data: txnData });
                                        }}
                                        onViewFn={() => setSecurityDepositCRU({ modal: true, data: item, mode: 'view' })}
                                        onEditFn={() => setSecurityDepositCRU({ modal: true, data: item, mode: 'edit' })}
                                        onDeleteFn={() => {
                                            setDeleteSecurityDeposit({ modal: true, data: item });
                                            setBulk({ modal: false, ids: [], title: '', type: '', txnType: '', securitySlug: '' });
                                        }}
                                        onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                        onTxnFnAttachments={(txnData, txnType) => setAttachments({ modal: true, data: txnData, txnType: txnType })}
                                        onTxnFn={(txntype, modeType, txndata) => setTxnCRU({ modal: true, data: txndata ? txndata : item?.security_deposit_type?.value === 1 ? cashTxnObj : nonCashTxnObj, mode: modeType, txntype: txntype, securitydata: item })}
                                    />
                                </div>
                              )
                            }
                            ) : <Paper square><Box sx={{ textAlign: "center", color: "var(--primary-color)", fontSize: "13px", fontWeight: "500", backgroundColor: "#e6ebfb", padding: 1, }}>No Record Found</Box></Paper>
                            }

                        </>)}
                    </div>
                </div>
            </Paper>
            {securityDepositCRU?.modal ?
                <SecurityDepositCRU
                   fileUpload={handleUpload}
                    modeType={securityDepositCRU?.mode}
                    securityDepositCRU={securityDepositCRU}
                    getResponseBack={() => getSecurityDepositList('')}
                    onToggleModal={() => setSecurityDepositCRU({ modal: false, data: null, mode: '' })}
                    onOpenAttachments={() => setAttachments({ modal: true, data: securityDepositCRU?.data, mode:'view' })}
                    sdcData={sdcData}
                />
                : null}
            {bulk.modal || deleteSecurityDeposit.modal || deleteTxn.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteSecurityDeposit.modal ? deleteSecurityDeposit.modal : deleteTxn?.modal}
                    title={(() => {
                        if (deleteSecurityDeposit.modal) return "Delete Security Deposit";
                        const selectedTxnType = Number( bulk.modal ? bulk?.txnType : deleteTxn?.data?.security_deposit_type?.value || securityDepositInfo?.find((record) => record?.slug === deleteTxn?.data?.security_deposit_slug)?.security_deposit_type?.value );
                        if (bulk.modal) {
                            const activeSecurity = securityDepositInfo?.find((record) =>
                                record?.slug === bulk?.securitySlug || record?.slug === bulk?.ids?.[0]?.security_deposit_slug
                            );
                            const totalTxnCount = activeSecurity?.transactions?.length || 0;
                            const isAllTxnSelected = totalTxnCount > 0 && bulk?.ids?.length === totalTxnCount;
                            if (selectedTxnType === 1) return isAllTxnSelected ? "Delete All Cash Txn" : "Delete Selected Cash Txn";
                            return isAllTxnSelected ? "Delete All Non Cash Txn" : "Delete Selected Non Cash Txn";
                        }
                        return selectedTxnType === 1 ? "Delete Cash Txn" : "Delete Non Cash Txn";
                    })()}
                    onDeleteRecords={() => bulk.modal || deleteTxn?.modal ? deleteTxnFn() : deleteSecurityDepositFn()}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [], title: '', type: '', txnType: '', securitySlug: '' });
                            return;
                        }
                        if (deleteSecurityDeposit.modal) {
                            setDeleteSecurityDeposit({ modal: false, data: null });
                            return;
                        }
                        setDeleteTxn({ modal: false, data: null });
                        setBulk({ modal: false, ids: [], title: '', type: '', txnType: '', securitySlug: '' });
                    }}
                /> : null
            }
            {txnCRU?.modal && txnCRU?.txntype === 1 ?
                <CashTxnCRU
                    fileUpload={handleUpload}
                    securitydata={txnCRU?.securitydata}
                    txnCRU={txnCRU}
                    modeType={txnCRU?.mode}
                    sortInfo={sortInfo}
                    getSortingWiseData={(query,securitySlug)=>getTxnListApi(query, securitySlug)}
                    getResponseBack={() => getSecurityDepositList('')}
                    onOpenAttachments={(txnType) => setAttachments({ modal: true, data: txnCRU?.data, txnType: txnType, mode:'view' })}
                    onToggleModal={() => setTxnCRU({ modal: false, data: null, mode: '', txntype: '', securitydata: null })}
                    sdcData={sdcData}
                /> : null
            }
            {txnCRU?.modal && txnCRU?.txntype === 2 ?
                <NonCashTxnCRU
                    fileUpload={handleUpload}
                    securitydata={txnCRU?.securitydata}
                    txnCRU={txnCRU}
                    modeType={txnCRU?.mode}
                    sortInfo={sortInfo}
                    getSortingWiseData={(query,securitySlug)=>getTxnListApi(query, securitySlug)}
                    getResponseBack={() => getSecurityDepositList('')}
                    onOpenAttachments={(txnType) => setAttachments({ modal: true, data: txnCRU?.data, txnType: txnType,mode:'view' })}
                    onToggleModal={() => setTxnCRU({ modal: false, data: null, mode: '', txntype: '', securitydata: null })}
                    sdcData={sdcData}
                /> : null}
            {attachments?.modal ?
                <ShowAttachments
                    moduleName={attachments?.txnType === 1 ? "Cash Only" : attachments?.txnType === 2 ? "Letter of Credit" : "Security Deposit"}
                    url='delete-attachment'
                    permissionKey='security_deposit'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null,mode:'' })}
                    onViewDisabled={securityDepositCRU?.mode === 'view' || txnCRU?.mode === 'view' || attachments?.mode==='view'}
                /> : null
            }
             {
              revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"security_deposit"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
            />
             }

            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(SecurityDeposit, { application: 'lease_revamp', feature: 'security_deposit', operationType: ['R'], leaseNav: true });
